import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import "./App.css";
import logoSvant from "./img/svant-logo.svg";

export default function Visualizar() {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000';
  const [data, setData] = useState([]);
  const getChartData = (data, names) => data.filter(item => names.includes(item.name)).sort((a, b) => b.KgCO2e - a.KgCO2e);
  const fixedNames = ['Energía eléctrica', 'Consumo gas', 'Logística'];
  const dynamicNames = ['Traslado aéreo', 'Traslado terrestre', 'Hotelería'];
  const chartFixed = getChartData(data, fixedNames);
  const chartDynamic = getChartData(data, dynamicNames);
  const [registrosTotales, setRegistrosTotales] = useState(0);
  const [emisionesTotales, setEmisionesTotales] = useState(0);
  const [estimativoPercapita, setEstimativoPercapita] = useState(0);
  const [participacionPorcentaje, setParticipacionPorcentaje] = useState(0);
  const [emissions, setEmissions] = useState([]);


  const handlePrint = () => { window.print(); };
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BACKEND_URL}/visual-data`)
      .then((res) => res.json())
      .then((response) => {
        setData(response.data || []);
        setRegistrosTotales(response.registrosTotales || 0);
        setEmisionesTotales(response.emisionesTotales || 0);
        setEstimativoPercapita(response.estimativoPercapita || 0);
        setParticipacionPorcentaje(response.participacionPorcentaje || 0);
      })
      .catch((error) => {
        console.error("Error al obtener datos:", error);
      });

    fetch(`${BACKEND_URL}/dashboard-tables`)
      .then((res) => res.json())
      .then((response) => {
        setEmissions(response.emissions || []);
      })
      .catch((error) => {
        console.error("Error al obtener tablas del dashboard:", error);
      });
  }, []);

  return (
    <div className='container'>
      <div className='containerFlex'>
        <div className='card flexBetween printHeader'>
          <img
            className='logoSvant'
            src={logoSvant}
            alt="Svant Measure and Act"
          />

          <div>
            <button className='btnPrint' onClick={handlePrint}>
              Imprimir
            </button>
            <button onClick={() => navigate('/')}>
              Agregar registros
            </button>
          </div>

        </div>
      </div>

      <div className='containerFlex'>
        <div className='card-2 printData'>
          <h2>Cantidad de registros</h2>
          <div className={"totalEmission"}>
            {registrosTotales} registros
          </div>
        </div>
        <div className='card-2 printData'>
          <h2>Porcentaje participación</h2>
          <div className={"totalEmission"}>
            {participacionPorcentaje.toFixed(2)} %
          </div>
        </div>
      </div>

      <div className='containerFlex'>
        <div className='card-2 printData'>
          <h2>Emisión total del evento</h2>
          <div className={"totalEmission"}>
            {emisionesTotales.toFixed(2)} Kg CO₂e
          </div>
        </div>
        <div className='card-2 printData'>
          <h2>Estimativo per capita</h2>
          <div className={"totalEmission"}>
            {estimativoPercapita.toFixed(2)} Kg CO₂e
          </div>
        </div>
      </div>

      <div className='containerFlex'>
        <div className='card'>
          <h2>Emisiones fijas del evento</h2>
          <ResponsiveContainer width="100%" height={270}>
            <BarChart layout="vertical" data={chartFixed} margin={{ top: 0, right: 5, left: 35, bottom: 0 }} barSize={50}>
              <CartesianGrid strokeDasharray="2 2" />
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" />
              <Tooltip />
              <Legend />
              <Bar dataKey="KgCO2e" radius={[0, 5, 5, 0]} legendType="none">
                <Cell fill="#235B67" />
                <Cell fill="#227E79" />
                <Cell fill="#23A487" />
                <Cell fill="#23C998" />
                <Cell fill="#70D460" />
                <Cell fill="#A3C854" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className='card'>
          <h2>Emisiones móviles del evento</h2>
          <ResponsiveContainer width="100%" height={270}>
            <BarChart layout="vertical" data={chartDynamic} margin={{ top: 0, right: 5, left: 35, bottom: 0 }} barSize={50}>
              <CartesianGrid strokeDasharray="2 2" />
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" />
              <Tooltip />
              <Legend />
              <Bar dataKey="KgCO2e" radius={[0, 5, 5, 0]} legendType="none">
                <Cell fill="#235B67" />
                <Cell fill="#227E79" />
                <Cell fill="#23A487" />
                <Cell fill="#23C998" />
                <Cell fill="#70D460" />
                <Cell fill="#A3C854" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className='card'>
        <h2>Emisiones por usuario</h2>
        <table>
          <colgroup span="6" aling="left" valing="middle"></colgroup>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Horas vuelo</th>
              <th>Transporte terrestre</th>
              <th>¿Hotel?</th>
              <th>Total CO₂</th>
            </tr>
          </thead>
          <tbody>
            {emissions.map((e) => (
              <tr key={e.id_user_response}>
                <td>{e.id_user_response}</td>
                <td>{e.first_name}</td>
                <td>{e.last_name}</td>
                <td>{e.travel_time}</td>
                <td>{e.event_transport}</td>
                <td>{e.stayed_in_hotel ? 'Sí' : 'No'}</td>
                <td><b>{e.co2_total_per_user?.toFixed(2)} Kg</b></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h4 className='printTitle'>Reporte generado para</h4><h4 className='printTitle'><b id='eventName'></b></h4>
    </div>
  );
}
